import { render, staticRenderFns } from "./books.vue?vue&type=template&id=2010aa57&scoped=true"
import script from "./books.vue?vue&type=script&lang=js"
export * from "./books.vue?vue&type=script&lang=js"
import style0 from "./books.vue?vue&type=style&index=0&id=2010aa57&prod&lang=scss&scoped=true"
import style1 from "./books.vue?vue&type=style&index=1&id=2010aa57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010aa57",
  null
  
)

export default component.exports